export default "__VITE_ASSET__CYIDwrCo__"